import onElementExists from "../lib/onElementExists";

// Prevent double-submission of any form in the DOM with a non-false data-prevent-double-submit attribute by disabling
// the submitter on submit. Use data: { prevent_double_submit: true } with Rails helpers. This is useful when Turbo,
// which normally provides this behavior automatically, is disabled (e.g. login controllers, as of June 2026)
onElementExists("form[data-prevent-double-submit]:not([data-prevent-double-submit=\"false\"])", (form : HTMLFormElement) => {
  const onsubmit = (event: SubmitEvent) => {
    const submitter = event.submitter as HTMLButtonElement | HTMLInputElement | null;
    if (!submitter || submitter.disabled) { return }
    submitter.disabled = true;
  };
  form.addEventListener("submit", onsubmit);
  return () => form.removeEventListener("submit", onsubmit);
});
